
import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Disclaimer() {
  return (
    <div className="container max-w-4xl py-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Disclaimer</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-[600px] pr-4">
            <div className="space-y-6">
              <section>
                <h2 className="text-xl font-semibold mb-3">1. Information Accuracy</h2>
                <p className="text-muted-foreground">
                  ChargeShare provides information about charging stations as a convenience to our users. While we strive to maintain accurate and up-to-date information, we cannot guarantee the complete accuracy, reliability, or availability of all listed charging stations.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">2. No Warranty</h2>
                <p className="text-muted-foreground">
                  The information and services provided by ChargeShare are offered "as is" without any warranties, express or implied. We do not guarantee the performance, condition, or availability of any charging station listed on our platform.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">3. User Responsibility</h2>
                <p className="text-muted-foreground">
                  Users are responsible for verifying the condition, availability, and suitability of charging stations before use. ChargeShare is not liable for any inconvenience, damage, or loss resulting from the use of information provided on our platform.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">4. Third-Party Interactions</h2>
                <p className="text-muted-foreground">
                  ChargeShare facilitates connections between EV owners and charging station hosts. We are not directly responsible for the interactions, transactions, or agreements between users and hosts. Users engage with each other at their own risk.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">5. Limitation of Liability</h2>
                <p className="text-muted-foreground">
                  In no event shall ChargeShare be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from the use of our platform or the information provided therein.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">6. Changes to Disclaimer</h2>
                <p className="text-muted-foreground">
                  We reserve the right to modify this disclaimer at any time. Users are encouraged to review this page periodically for any updates.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">7. Contact Information</h2>
                <p className="text-muted-foreground">
                  For any questions or concerns regarding this disclaimer, please contact us at disclaimer@chargeshare.com
                </p>
              </section>
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
}
